/**
 * order item endpoint instance
 * instantiate order item api class with a different api path
 */
import { OrderItemEndpoints } from '@/modules/order-management/order-items/api/orderItemEndpoints'
import { IOrderItems } from '@/modules/order-management/order-items/types/orderTypes'

export const orderItemEndpoints = new OrderItemEndpoints<IOrderItems>()
